import config from '../../../config/config';
import getRequest from '../base/get';

interface QueryParameters {
  [key: string]: any;
}

export default {
  /**
   * Fetch total connectors count.
   */
  getConnectorCount: () =>
    getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/total-connectors`),
  /**
   * Fetch total charging stations count.
   */
  getStationCount: () =>
    getRequest(`${config.commonApiUrl}api/facility/v1/charging-station/total-charging-stations`),
  /**
   * Fetch total charging points count.
   */
  getChargingPointCount: () =>
    getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/total-charging-points`),
  /**
   * Fetch total faulted connectors count.
   */
  getDefectCount: () =>
    getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/total-faulted-connectors`),
  /**
   * Fetch charging stations map.
   */
  getStationMap: () =>
    getRequest(`${config.commonApiUrl}api/facility/v1/charging-station/charging-stations-map`),
  /**
   * Fetch charging station details by id.
   * @param {any} id Charging station id
   */
  getStationDetails: (id: string) =>
    getRequest(
      `${config.commonApiUrl}api/facility/v1/charging-station/charging-stations-map/${id}`,
    ),
  /**
   * Fetch end consumers month wise.
   */
  getEndConsumersMonthWise: () =>
    getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/end-consumers-month-wise`,
    ),
  /**
   * Fetch power consumed month wise.
   */
  getPowerConsumedMonthWise: () =>
    getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/power-consumed-month-wise`,
    ),
  /**
   * Fetch revenue month wise.
   */
  getRevenueMonthWise: () =>
    getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/power-consumed-month-wise`,
    ),
  /**
   * Fetch power consumption report.
   * @param {any} query Query parameters for report
   */
  getPowerConsumedReport: (query: QueryParameters) =>
    getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/power-consumption-report`,
      { ...query },
    ),
  /**
   * Fetch connector status report.
   */
  getConnectorStatusReport: () =>
    getRequest(`${config.reportApiUrl}api/facility/v1/charging-point/connector-status-report`),
  /**
   * Fetch device status report.
   */
  getDeviceStatusReport: () =>
    getRequest(`${config.reportApiUrl}api/facility/v1/charging-point/device-status-report`),
  /**
   * Fetch alerts report.
   * @param {any} query Query parameters for alerts report
   */
  getAlertsReport: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/facility/v1/charging-point/alerts-report`, { ...query }),
  /**
   * Fetch schedule charging report.
   * @param {any} query Query parameters for schedule charging report
   */
  getScheduleChargingReport: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/facility/v1/charging-point/schedule-charging-report`, {
      ...query,
    }),
  /**
   * Fetch station performance report.
   * @param {any} query Query parameters for station performance report
   */
  getStationPerformanceReport: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/facility/v1/charging-point/station-performance-report`, {
      ...query,
    }),
  /**
   * Fetch device active/idle report.
   * @param {any} query Query parameters for device active/idle report
   */
  getDeviceActiveIdleReport: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/facility/v1/charging-point/device-active-idle-report`, {
      ...query,
    }),
  /**
   * Fetch device utilization report.
   * @param {any} query Query parameters for device utilization report
   */
  getDeviceUtilizationReport: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/facility/v1/charging-point/device-utilization-report`, {
      ...query,
    }),
  /**
   * Fetching active device counts
   */
  fetchActiveDeviceCounts: () => {
    return getRequest(
      `${config.commonApiUrl}api/facility/v1/charging-point/active-charging-points`,
    );
  },
};
